<script lang="ts" setup>
const props = defineProps<{
    pager: Pager;
}>();

const emit = defineEmits<{
    (e: 'change', pager: Pager): void;
}>();

const options: Option<number>[] = [
    { value: 10, text: '10' },
    { value: 20, text: '20' },
    { value: 50, text: '50' },
    { value: 100, text: '100' }
];

const onChange = (value: number): void =>
{
    props.pager.setPageSize(value);

    emit('change', props.pager);
};
</script>

<template>
    <IdeoFormSelect :model-value="pager.pageSize" :options="options" @update:model-value="onChange" />
</template>
